import { render, staticRenderFns } from "./ArquivoItem.vue?vue&type=template&id=55df46a5&scoped=true&"
import script from "./ArquivoItem.vue?vue&type=script&lang=js&"
export * from "./ArquivoItem.vue?vue&type=script&lang=js&"
import style0 from "./ArquivoItem.vue?vue&type=style&index=0&id=55df46a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df46a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VIcon,VListItem,VListItemAction,VListItemAvatar,VListItemContent,VListItemTitle})
